<template>
  <v-flex x12 sm12 d-block class="card-dados card-dados__mobile" style="border: .08em solid #eee">
    <p class="card-dados__titulo mb-0" style="font-weight: 600; color: #777; background-color: #cfcfcf; padding: 0.6rem 0.8rem;">Anexos</p>
    <v-data-table :headers="this.filtrarColunas" :items="value" :total-items="value.length"
                  :loading="false" no-data-text="Não há arquivos adicionados" hide-actions
                  class="az-text az-table-list table-arquivos-consulta">
      <template slot="items" slot-scope="props" style="background-color: #ebebeb">
        <td>
          {{ props.item.documentoId }}
        </td>
        <td>
          {{ props.item.criadoEm | az-date(formatosDefault.DATA) }}
        </td>
        <td>
          {{ props.item.nome }}
        </td>
        <td class="table-actions">
          <botao-download class="actions-item" v-if="props.item.uri || props.item.idVirtualizado"
                          :documento="props.item"
                          @baixarDocumentos="tratarEventDownloadAnexo($event, props.item)"/>
        </td>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import azAuth from '@azinformatica/loki/src/utils/az-auth'
import BotaoDownload from '@/views/components/BotaoDownload'

export default {
    name: 'PainelAnexoVisualizacao',
    components: {
        BotaoDownload
    },
    props: {
        value: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        situacaoCompraDireta: {
            type: String,
            default: 'ABERTA'
        }
    },
    data() {
        return {
            formatosDefault: {
                DATA: 'DD/MM/YYYY',
                DATA_HORA: 'DD/MM/YYYY [-] HH[h]',
                DATA_HORA_MINUTO: 'DD/MM/YYYY [-] HH[h] mm[min]',
                HORA: 'HH[h] mm[min]'
            },
            colunas: [
                {
                    value: 'tipo',
                    text: 'Tipo',
                    align: 'left',
                    sortable: true,
                    width: '80px',
                    class: 'primary--text'
                },
                {
                    value: 'data',
                    text: 'Data',
                    align: 'left',
                    sortable: true,
                    width: '50px',
                    class: 'primary--text'
                },
                {
                    value: 'nome',
                    text: 'Nome',
                    align: 'left',
                    sortable: true,
                    width: '200px',
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    align: 'center',
                    width: '30px',
                    text: 'Ações',
                    class: 'primary--text'
                },
            ]
        }
    },
    computed: {
        filtrarColunas() {
            return this.colunas
        }
    },
    methods: {
        azAuth,
        tratarEventDownloadAnexo(tipoDownload, anexo) {
            const payload = {
                tipoDownload: tipoDownload,
                anexo: anexo
            }
            this.$emit('downloadAnexo', payload)
        },
    },
    filters: {
        documentoFilter(docId, documentos) {
            const documentosEncontados = documentos.filter(doc => doc.id === docId)
            if (documentosEncontados.length > 0) {
                return documentosEncontados[0].nome
            }
            return ''
        }
    }
}
</script>

<style scoped lang="stylus">
.table-arquivos-consulta
  padding 0 16px 16px

  tr:last-child
    border-bottom 0 !important

.table-actions span
  display inline-block
  flex-wrap wrap

@media (max-width 720px)
  .table-arquivos-consulta
    padding 0

  td:nth-of-type(1):before
    content "Tipo:"

  td:nth-of-type(2):before
    content "Data:"

  td:nth-of-type(3):before
    content "Nome:"

  td:nth-of-type(4):before
    content "Situação:"

  td:nth-of-type(5):before
    display none
</style>
